import { baseService } from './BaseService';

class NotificationService extends baseService {
    // USER
    getMyNotifications = (page = 0, size = 15) =>
        this.get(`api/v1/notifications/my?page=${page}&size=${size}`, true);

    getUnreadCount = () =>
        this.get('api/v1/notifications/unread-count', true);

    markRead = (id) =>
        this.put(`api/v1/notifications/${id}/read`, {});

    markAllRead = () =>
        this.put('api/v1/notifications/read-all', {});

    // ADMIN
    send = (body) =>
        this.post('api/v1/notifications/send', body);

    getAll = (page = 0, size = 20) =>
        this.get(`api/v1/notifications/admin?page=${page}&size=${size}`, true);

    deleteNotification = (id) =>
        this.delete(`api/v1/notifications/${id}`);
}

export const notificationService = new NotificationService();
